import { useContext } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import { Link } from "react-router-dom";
import "./EnhObjektifUnsurlar.css";


export default function EnhObjektifUnsurlar() {
  const {
    odaNedenleri,
    objektifUnsurlar,
    setObjektifUnsurlar,
    odaToplam,
    setOdaToplam,
    odaVerilecek,
    setOdaVerilecek,
  } = useContext(GlobalContext);

  const handleServiceChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...objektifUnsurlar];
    list[index][name] = value;
    setObjektifUnsurlar(list);
    console.log(list);

    setOdaToplam(0);
    var toplam = 0;
    list.map((item) => {
      toplam = toplam + parseFloat(item.etkiOrani);
      console.log(toplam);
      return toplam;
    });
    setOdaToplam(toplam);
  };

  const handleServiceRemove = (index) => {
    const list = [...objektifUnsurlar];
    list.splice(index, 1);
    setObjektifUnsurlar(list);

    setOdaToplam(0);
    var toplam = 0;
    list.map((item) => {
      toplam = toplam + parseFloat(item.etkiOrani);
      console.log(toplam);
      return toplam;
    });
    setOdaToplam(toplam);
  };

  const handleServiceAdd = () => {
    setObjektifUnsurlar([
      ...objektifUnsurlar,
      { odaNedeni: "", etkiOrani: "" },
    ]);

    setOdaToplam(0);
    var toplam = 0;
    objektifUnsurlar.map((item) => {
      toplam = toplam + parseFloat(item.etkiOrani);
      console.log(toplam);
      return toplam;
    });
    setOdaToplam(toplam);
  };

  const unsurlarıYazdir = () => {
    console.log(objektifUnsurlar);
  };

  const odaVerilmeyecektir = () => {
    setOdaVerilecek(false);
    setObjektifUnsurlar([]);
    setOdaToplam(0);
  };

  const odaVerilecektir = () => {
    setOdaVerilecek(true);
    setObjektifUnsurlar([{}]);
  };

  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center mt-5">
            Taşınmaz Değerine Etki Edecek Objektif Değer Artış Unsurları
          </h1>
        </div>
        <div className="row my-5">
          <h3>Taşınmaz Değerini Artıran Unsurlar ve Etki Oranlarını Giriniz</h3>
        </div>
        <div className="row">
          <div className="col-8">
            <div className="form-check">
              <input
                className="form-check-input "
                type="radio"
                name="odaDurumu"
                id="odaVerilmeyecek"
                checked={odaVerilecek === false ? true : false}
                onChange={() => odaVerilmeyecektir()}
              />
              <label className="form-check-label" htmlFor="odaVerilmeyecek">
                Objektif Değer Artışı{" "}
                <b className="text-danger">Uygulanmayacaktır.</b>
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="odaDurumu"
                id="odaVerilecek"
                checked={odaVerilecek === true ? true : false}
                onChange={() => odaVerilecektir()}
              />
              <label className="form-check-label" htmlFor="odaVerilecek">
                Objektif Değer Artışı <b>Uygulanacaktır.</b>
              </label>
            </div>
          </div>
          <div className="col-4">
            {odaVerilecek ? <h2>Toplam ODA: {odaToplam}</h2> : ""}
          </div>
        </div>

        <div className="row">
          <div className="col mt-1 mb-2 mx-2">
            {odaVerilecek
              ? objektifUnsurlar.map((unsur, index) => (
                  <div
                    key={index}
                    className="row border border-primary rounded mt-2"
                  >
                    <div className="col my-1">
                      <div className="input-group">
                        <span className="input-group-text bg-primary">
                          {index + 1}
                        </span>
                        <select
                          name="odaNedeni"
                          onChange={(e) => handleServiceChange(e, index)}
                          className="form-control"
                          value={objektifUnsurlar[index].odaNedeni}
                        >
                          <option>--Seçiniz--</option>
                          {odaNedenleri.map((neden, index) => (
                            <option key={index}>{neden.name}</option>
                          ))}
                        </select>

                        <input
                          name="etkiOrani"
                          type="number"
                          id="etkiOrani"
                          className="form-control mx-2"
                          onChange={(e) => handleServiceChange(e, index)}
                          value={objektifUnsurlar[index].etkiOrani}
                          placeholder="Artış Etki Oranı %"
                          required
                        />
                        {objektifUnsurlar.length - 1 === index &&
                          objektifUnsurlar.length < 10 && (
                            <button
                              type="button"
                              onClick={handleServiceAdd}
                              className="btn btn-primary"
                            >
                              <span>Objektif Unsur Ekle</span>
                            </button>
                          )}
                      </div>
                    </div>
                    <div className="col-2 my-1">
                      {objektifUnsurlar.length !== 1 && (
                        <button
                          type="button"
                          onClick={() => handleServiceRemove(index)}
                          className="btn btn-danger"
                        >
                          <span>Sil</span>
                        </button>
                      )}
                    </div>
                  </div>
                ))
              : ""}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="row">
              <Link to="/enhmunavebeuygula">
                <button className="btn btn-success btn-lg mt-5">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-left-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"
                    />
                  </svg>{" "}
                  Münavebe ve Değerleme
                </button>
              </Link>
            </div>
          </div>
          <div className="col"></div>
          <div className="col"></div>
          <div className="col">
            <div className="row">
              {" "}
              <Link to="/enhagacdegerleme">
                {" "}
                <button
                  onClick={unsurlarıYazdir}
                  className="btn btn-primary btn-lg mt-5"
                >
                  Ağaç Değerleme
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    className="bi bi-arrow-right-circle"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                    />
                  </svg>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </GlobalProvider>
  );
}
